// extracted by mini-css-extract-plugin
module.exports = {"container":"GlobalInfoBanner_container__2OfTx","inner":"GlobalInfoBanner_inner__newjU","icon":"GlobalInfoBanner_icon__HYN17"};